import Vue from 'vue'
import Router from 'vue-router'

/**
 * Components
 */
import UserEditor from '@/components/Users/UserEditor'
import UserList from '@/components/Users/UserList'
import UserInstall from '@/components/Users/UserInstall'

import Login from '@/components/Login'
import Profile from '@/components/Profile'
import Uiexamples from '@/components/Uiexamples'
import Imprint from '@/components/Imprint'

import GuidelineList from '@/components/Guideline/GuidelineList'
import GuidelinePreApproveDraft from '@/components/Guideline/GuidelinePreApproveDraft'
import GuidelineEditor from '@/components/Guideline/GuidelineEditor'
import GuidelineView from '@/components/Guideline/GuidelineView'
import GuidelineUpload from '@/components/Guideline/GuidelineUpload'
import GuidelineCoiManagment from '@/components/Guideline/GuidelineCoiManagment'
import GuidelineGpcReview from "@/components/Guideline/GuidelineGpcReview/index.vue";
import GuidelineReview from '@/components/Guideline/GuidelineReview'
import GuidelineOnHold from '@/components/Guideline/GuidelineOnHold'
import GuidelineNdReview from '@/components/Guideline/GuidelineNdReview'
import GuidelineBoardProcess from '../components/Guideline/GuidelineGpcFinalApprovalProcess'
import GuidelineFinalPublication from '@/components/Guideline/GuidelineFinalPublication'
import Statistics from '@/components/Statistics'

import ChangeLogs from '@/components/ChangeLogs'
import Settings from '@/components/Settings'

import store from '../store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'GuidelinesList',
      component: GuidelineList,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },

    /**
     * Users
     */
    {
      path: '/users/:page(\\d+)?',
      component: UserList,
      name: 'Users',
    },
    {
      path: '/users/add',
      name: 'UserAdd',
      component: UserEditor,
    },
    {
      path: '/users/:id(\\d+)/edit',
      name: 'UserEdit',
      component: UserEditor,
    },

    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
    },
    /**
     * Users - end
     */

    /**
     * Guidelines
     */
    {
      path: '/guidelines/:page(\\d+)?',
      name: 'Guidelines',
      component: GuidelineList,
      props: {phase: null}
    },
    {
      path: '/guidelines/pre-approve-draft',
      component: GuidelinePreApproveDraft
    },
    {
      path: '/guidelines/add',
      component: GuidelineEditor
    },
    {
      path: '/guidelines/:id(\\d+)/edit',
      component: GuidelineEditor
    },
    {
      path: '/guidelines/:id(\\d+)/view',
      component: GuidelineView
    },
    {
      path: '/guidelines/:id(\\d+)/upload',
      component: GuidelineUpload
    },
    {
      path: '/guidelines/:id(\\d+)/gpc-review',
      component: GuidelineGpcReview
    },
    {
      path: '/guidelines/:id(\\d+)/review',
      component: GuidelineReview
    },
    /**
     * Guidelines - end
     */

    /**
     * Guideline Review
     */
    {
      path: '/guidelines/:id(\\d+)/nd-review',
      component: GuidelineNdReview
    },

    /**
     * Guideline gpc/board on hold
     */
    {
      path: '/guidelines/:id(\\d+)/on-hold',
      component: GuidelineNdReview
    },

    /**
     * Guideline Review
     */
    
    /**
     * Guideline board-process
     */
    {
      path: '/guidelines/:id(\\d+)/gpc-final-approval-process',
      component: GuidelineBoardProcess
    },
    /**
     * Guideline board-process
     */


    /**
     * Guideline final-publication
     */
    {
      path: '/guidelines/:id(\\d+)/final-publication',
      component: GuidelineFinalPublication
    },
    /**
     * Guideline final-publication
     */
    
    /**
     * Guideline coi-managment
     */
    {
      path: '/guidelines/:id(\\d+)/coi-managment',
      component: GuidelineCoiManagment
    },
    /**
     * Guideline coi-managment
     */

    {
      path: '/logs',
      name: 'Logs',
      component: ChangeLogs,
    },

    {
      path: '/imprint',
      name: 'Imprint',
      component: Imprint,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/uiexamples',
      name: 'UI examples',
      component: Uiexamples,
    },

    {
      path: '/users-install',
      name: 'UsersInstall',
      component: UserInstall,
    },

    /**
     * Statistics
     */
    {
      path: '/stats',
      name: 'Statistics',
      component: Statistics,
    },

    {
      path: '*',
      component: {
        template: '<div class="padding"><p>Page Not Found</p></div>'
      }
    }
  ],
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  if (!store.getters.isAuthenticated && (to.name == "UsersInstall")) {
    return next();
  }

  if (!store.getters.isAuthenticated && to.name != "Login") {
    if (to.query.code) {
      return next('/login?code=' + to.query.code);
    }

    return next('/login');
  }

  next();
})

export default router;
